// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ThunderboltFilledSvg from "@ant-design/icons-svg/es/asn/ThunderboltFilled";
import AntdIcon from '../components/AntdIcon';

var ThunderboltFilled = function ThunderboltFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ThunderboltFilledSvg
  }));
};

ThunderboltFilled.displayName = 'ThunderboltFilled';
export default React.forwardRef(ThunderboltFilled);